/* eslint-disable camelcase */
import { isInt } from '../utils/utils'

const getQueryToApiParams = isClientsCompanies => {
  return {
    id: 'id',
    title: 'title',
    name: 'name',
    role: 'role'
  }
}

const addSearchParam = (data, searchParam) => {
  const params = data

  if (isInt(searchParam)) {
    params.filter = {
      self_id: searchParam
    }

    return params
  }

  params.search = { value: searchParam }

  return params
}
const getApiParameter = (key, query, isClientsCompanies) => {
  if (
    query.hasOwnProperty(key) &&
    getQueryToApiParams(isClientsCompanies).hasOwnProperty(key)
  ) {
    return getQueryToApiParams(isClientsCompanies)[key]
  }

  return false
}
const addCommonParams = (data, query, isClientsCompanies) => {
  const queryKeys = Object.keys(query)
  const params = data

  params.filter = {}

  queryKeys.forEach(key => {
    const param = getApiParameter(key, query, isClientsCompanies)

    if (param) {
      params.filter[param] = query[key]
    }
  })

  return params
}

export default {
  methods: {
    createClientsParams (query) {
      const isClientsCompanies = this.$route.name === 'clients.users'

      const search = query['search']

      let resultParams = {}

      resultParams = addSearchParam(resultParams, search)

      if (!isInt(search)) {
        resultParams = addCommonParams(resultParams, query, isClientsCompanies)
      }

      return resultParams
    }
  }
}
